import { HttpContext } from '@angular/common/http';

import { INVALIDATE_CACHE } from '../interceptors/cache.interceptor';
import { IGNORE_ERRORS } from '../interceptors/error.interceptor';

export interface ServiceCallOptions {
  invalidateCache?: boolean;
  ignoreErrors?: boolean;
}

export const useCallOptions = (
  options?: ServiceCallOptions
): { context: HttpContext } => ({
  context: new HttpContext()
    .set(INVALIDATE_CACHE, options?.invalidateCache || false)
    .set(IGNORE_ERRORS, options?.ignoreErrors || false),
});
